module.exports = __webpack_public_path__ + "static/beaver-8ead7d1c615c4603292a460104d2a6f9.png";